import * as api from '../../../../api';

export interface UpdateInsuranceFormValue
  extends Omit<
    Partial<api.PrevisitPatientInsurance.PrevisitInsuranceFormFieldValue>,
    'footprint'
  > {
  footprint: api.PrevisitPatientInsurance.Footprint;
}

interface EntityState<EntityType, EntityError> {
  started: boolean;
  completed: boolean;
  error: EntityError | null;
  results: EntityType | null;
}

export type OcrState = EntityState<
  api.InsuranceCardOcrResult.InsuranceCardOcrResult,
  string
>;

export type RteState = EntityState<
  api.PatientRealTimeEligibility.RealTimeEligibilityResults,
  Omit<
    api.PatientRealTimeEligibility.EligibilityResponse,
    api.PatientRealTimeEligibility.EligibilityResponse.Active
  >
>;

export const INITIAL_OCR_STATE: OcrState = {
  started: false,
  completed: false,
  error: null,
  results: null,
};

export const INITIAL_RTE_STATE: RteState = {
  started: false,
  completed: false,
  error: null,
  results: null,
};

export const MEDICARE_PAYORS = [
  api.PatientInsuranceInformation.Payor.Medicare,
  'NATIONAL_MEDICARE_CMS',
];
